import React from "react";
import { Check } from "lucide-react";
import PhotoImage from "./PhotoImage";
import FondoEstudio from "./FondoEstudio";
import WhatsAppCta from "./WhatsAppCta";
import { CAMPANA, FOTO, campanaActiva, hastaTexto } from "../../data/campana";
import { PRECIOS, etiquetaPrecio } from "../../data/precios";

/**
 * El banner de la campaña de temporada.
 *
 * TEXTO DE VERDAD, NO UN PNG CON LETRAS DENTRO. La versión en imagen del
 * banner existe y es tentadora — ya está diseñada —, pero un banner horneado
 * no se reflowea a 375 px (el original es 3:1, ilegible en un teléfono), no
 * se indexa, no se puede copiar y deja el precio fuera de precios.js, que es
 * justo lo que este repo evita: el día que cambie, la web diría una cosa y la
 * imagen otra. La foto va de fondo y el precio sale del dato.
 *
 * SEGUNDA DIAPOSITIVA DEL CARRUSEL del inicio. De ahí salen dos decisiones
 * que de otro modo parecerían arbitrarias: la foto va con `priority` aunque
 * no sea la primera en pantalla —una imagen diferida dentro de una
 * diapositiva oculta no la descarga Chrome, y al rotar se vería el hueco— y
 * las medidas de alto copian las del hero, porque las dos comparten celda y
 * el carrusel mide lo que la más alta: desigualarlas deja un bloque vacío.
 *
 * Desaparece sola pasada la fecha (ver data/campana.js), y ahí el carrusel se
 * queda con una diapositiva y se dibuja sin controles.
 */
const FotoCampana = () => {
  if (!campanaActiva()) return null;

  return (
    <section
      id="navidad"
      className="relative overflow-hidden bg-navy-950 text-white"
      aria-labelledby="campana-titulo"
    >
      {/* Misma gramática que el hero: la foto a la derecha en escritorio y
          arriba en móvil, con el degradado que sostiene el texto. */}
      <div className="relative lg:absolute lg:inset-y-0 lg:left-[38%] lg:right-0">
        {FOTO ? (
          <PhotoImage
            foto={FOTO}
            sizes="(min-width: 1024px) 62vw, 100vw"
            priority
            className="aspect-[5/4] h-full w-full object-cover object-center lg:aspect-auto"
          />
        ) : (
          <FondoEstudio variante="rejilla" />
        )}
        <div
          className="absolute -inset-x-px inset-y-0 bg-gradient-to-t from-navy-950 via-navy-950/20 to-navy-950/40 lg:bg-[linear-gradient(90deg,#0B0A09_0%,rgba(11,10,9,0.94)_12%,rgba(11,10,9,0.5)_32%,rgba(11,10,9,0.08)_55%,rgba(11,10,9,0)_72%)]"
          aria-hidden="true"
        />
      </div>

      <div className="container-omega relative z-10 pb-20 pt-6 lg:flex lg:min-h-[88vh] lg:items-end lg:pb-28 lg:pt-40">
        <div className="max-w-xl">
          <p className="inline-flex items-center gap-2 rounded-full border border-sand-400/40 bg-navy-950/60 px-4 py-1.5 text-sm font-medium text-sand-200">
            <span className="h-1.5 w-1.5 rounded-full bg-sand-400" aria-hidden="true" />
            Hasta el {hastaTexto()}
          </p>

          <h2
            id="campana-titulo"
            className="mt-5 font-display text-3xl font-bold tracking-tight text-white sm:text-4xl md:text-5xl"
          >
            {CAMPANA.nombre}
          </h2>
          <p className="mt-4 max-w-md text-lg leading-relaxed text-navy-100">{CAMPANA.claim}</p>

          <p className="mt-7 font-display text-4xl font-extrabold tabular-nums text-white sm:text-5xl">
            {etiquetaPrecio(PRECIOS[CAMPANA.priceKey], { ivaIncluido: CAMPANA.ivaIncluido })}
            <span className="ml-3 font-display text-lg font-bold text-sand-300">
              {CAMPANA.volumen}
            </span>
          </p>

          <ul className="mt-6 space-y-2.5">
            {CAMPANA.incluye.map((item) => (
              <li key={item} className="flex items-start gap-2.5 text-navy-100">
                <Check className="mt-1 h-4 w-4 shrink-0 text-sand-400" aria-hidden="true" />
                <span>{item}</span>
              </li>
            ))}
          </ul>

          <WhatsAppCta
            message={CAMPANA.whatsapp}
            location="home_campana_navidad"
            variant="sand"
            className="mt-8 w-full sm:w-auto"
          >
            Reservar mi sesión
          </WhatsAppCta>
        </div>
      </div>
    </section>
  );
};

export default FotoCampana;
